import React, {useEffect, useState, useRef} from 'react'
import HeadingArea from '../../general/HeadingArea'
import { Bs1CircleFill, Bs2CircleFill, Bs3CircleFill, Bs4CircleFill, Bs5CircleFill } from 'react-icons/bs';
import { FaCheck, FaEye, FaEyeSlash } from 'react-icons/fa';
import ResponseMsg2 from '../../general/ResponseMsg2';

const AddStudent = ({setLoading}) => {
        const [response2, setResponse2] = useState({ message: '', status: 'success' });
        const [lastReg, setLastReg] = useState([]);
        const [showPassword, setShowPassword] = useState(false);
         const [classes, setClasses] = useState([]);
          const [availableSections, setAvailableSections] = useState([]);
           const [selectedClassId, setSelectedClassId] = useState('');
          const [selectedSection, setSelectedSection] = useState('');
          const [ay, setAy] = useState([]);
          const [showUploadSheet, setShowUploadSheet] = useState(false);
         const fileInputRef = useRef(null);
         const imageInputRef = useRef(null);
         const pdfInputRef = useRef(null);
        const [formData, setFormData] = useState({
          ay: '',
            name: '',
            reg_no: '',
            admission_no: '',
            roll_no: '',
            pen_no: '',
            apaar_no: '',
            dob: '',
            dor_reg: '',
            doa: '',
            class_id: '',
            section: '',
    gender: '',
    religion: '',
    nationality: '',
    father: '',
    f_occupation: '',
    f_mobile: '',
    f_qualification: '',
    f_email: '',
    mother: '',
    m_occupation: '',
    m_mobile: '', 
    m_qualification: '',
    m_email: '',
    address: '',
    blood_grp: '',
    mobile: '',
    email: '',
    pass: '',
    old_school_detail: '',
    category: '',
    m_tongue: '',
    siblings: [],
    single_girl_child: 'No',
    specially_abled: 'No',
    aadhaar_no: '',
    tc_no: '',
    tc_issue_date: '',
    fee_discount: '',
    // bank_name: '',
    // ifsc_code: '',
    // acc_holder: '',
    // acc_no: '',
    aadhaar_pic: null,
    profile_pic: null,
        });
    
         const [selectedFiles, setSelectedFiles] = useState([]);

  const handleButtonClick = () => {
    if (imageInputRef.current) {
      imageInputRef.current.click();
    }
  };


  const handleUpload = async () => {
  if (!selectedFiles.length) {
    alert("Please select files to upload.");
    return;
  }

  setLoading(true);
  const formData = new FormData();
  for (let i = 0; i < selectedFiles.length; i++) {
    formData.append('profiles', selectedFiles[i]);
  }

  try {
    const response = await fetch('https://api.kcian.in/bulk-upload-profiles', {
      method: 'POST',
      body: formData,
    });

    if (!response.ok) {
      throw new Error(`Server error: ${response.statusText}`);
    }

    const data = await response.json();
      setLoading(false);
                    setResponse2({ message: data.message || 'Images upload successful!', status: 'success' });
              setTimeout(() => {
          setResponse2('');
        }, 2000);   
    setSelectedFiles([]);
  } catch (error) {
      setLoading(false);
    console.error('Upload failed:', error);
    // alert('Failed to upload profiles.');
  }
};


    
const handleChange = (e) => {
  const { name, value, files } = e.target;

  setFormData((prev) => {
    const updatedForm = {
      ...prev,
      [name]: files ? files[0] : value,
    };

    if (name === 'mobile' && value.length === 10) {
      updatedForm.pass = value;
    }

    return updatedForm;
  });
};


  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    if (!file.name.endsWith('.xlsx') && !file.name.endsWith('.xls')) {
      alert('Please upload an Excel file (.xlsx or .xls)');
      return;
    }

    const formData = new FormData();
    formData.append('dataSheet', file);

    try {
      setLoading(true);
      const res = await fetch('https://api.kcian.in/upload-bulk-students', {
        method: 'POST',
        body: formData,
      });

      const data = await res.json();
      if (res.ok) {
                setResponse2({ message: data.message || 'Bulk upload successful!', status: 'success' });
      } else {
                setResponse2({ message: data.message || 'Something went wrong.', status: 'error' });        
      }
    } catch (error) {
      console.error('Error uploading:', error);
      // setResponseMsg('Server error. Please try again later.');
    } finally {
      setLoading(false);
              setTimeout(() => {
          setResponse2('');
        }, 2000);   
      e.target.value = '';
    }
  };


  const handleImageChange = (event) => {
    const files = event.target.files;
    if (files.length > 200) {
      alert("You can upload a maximum of 200 Images at once.");
      return;
    }
    setSelectedFiles(files);
  };
    

  
  const handlePdfChange = (e) => {
    const files = Array.from(e.target.files).slice(0, 200);
    setSelectedFiles(files);
  };


  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const submitData = new FormData();
 const selectedClass = classes.find(cls => cls.id === Number(selectedClassId));
    const className = selectedClass ? selectedClass.class_name : '';


for (const key in formData) {
      if (key === 'profile_pic') {
        if (formData.profile_pic) {
          submitData.append(key, formData.profile_pic);
        }
      } if (key === 'aadhaar_pic') {
        if (formData.aadhaar_pic) {
          submitData.append(key, formData.aadhaar_pic);
        }
      } else if (key == 'class_id') {
        // Instead of class_id, append class_name
        submitData.append('class_name', className);
      }  else if (key === 'siblings') {
    submitData.append('siblings', JSON.stringify(formData.siblings));
  } else {
        submitData.append(key, formData[key]);
      }
    }

      const response = await fetch('https://api.kcian.in/add-student', {
        method: 'POST',
        body: submitData,
      });

      const data = await response.json();

      if (response.ok) {
        setResponse2({ message: data.message || 'Student added successfully!', status: 'success' });
        fetchLastReg();

        setFormData({
          ay: '',
            name: '',
            reg_no: '',
            admission_no: '',
            roll_no: '',
            pen_no: '',
            apaar_no: '',
            dob: '',
            dor_reg: '',
            doa: '',
            class_id: '',
            section: '',
    gender: '',
    religion: '',
    nationality: '',
    father: '',
    f_occupation: '',
    f_mobile: '',
    f_qualification: '',
    f_email: '',
    mother: '',
    m_occupation: '',
    m_mobile: '', 
    m_qualification: '',
    m_email: '',
    address: '',
    blood_grp: '',
    mobile: '',
    email: '',
    pass: '',
    old_school_detail: '',
    category: '',
    m_tongue: '',
    siblings: [],
    single_girl_child: 'No',
    specially_abled: 'No',
    aadhaar_no: '',
    tc_no: '',
    tc_issue_date: '',
    fee_discount: '',
    // bank_name: '',
    // ifsc_code: '',
    // acc_holder: '',
    // acc_no: '',
    aadhaar_pic: null,
    profile_pic: null,
        });
        setSelectedClassId('');
setSelectedSection('');

        setTimeout(() => {
          setResponse2('');
        }, 2000);   
      } else {
        setResponse2({ message: data.message || 'Something went wrong. Please try again later.', status: 'error' });
        setTimeout(() => {
          setResponse2('');
        }, 2000);   
      }
    } catch (error) {
      console.error('Error submitting form:', error);
    }
  };

    const fetchLastReg = async () => {
                          setLoading(true);
                  try {
                      const response = await fetch('https://api.kcian.in/get-last-regno');
     
                      if (response.ok) {
                          const data = await response.json();
                          console.log(data);
                          setLastReg(data.reg_no);
                          setLoading(false);
                      } else {
                          setLoading(false);
                          setLastReg(null);
                      }
                  } catch (error) {
                      setLoading(false);
                      console.error('Error fetching data:', error);
                  }
    }


         const fetchClasses = async () => {
                           setLoading(true);
                   try {
                       const response = await fetch('https://api.kcian.in/get-classes');
       
                       if (response.ok) {
                           const data = await response.json();
                           setClasses(data);
                           setLoading(false);
                                                     console.log(data);

                       } else {
                           setLoading(false);
                           console.error('Failed to fetch class');
                       }
                   } catch (error) {
                       setLoading(false);
                       console.error('Error fetching data:', error);
                   }
     }


     const fetchAcademicYears = async () => {
  setLoading(true);
  try {
    const response = await fetch('https://api.kcian.in/get-academic-years');

    if (response.ok) {
      const data = await response.json();
      setAy(data);
    } else {
      console.error('Failed to fetch academic years');
    }
  } catch (error) {
    console.error('Error fetching data:', error);
  } finally {
    setLoading(false);
  }
};



  useEffect(() => {
    fetchLastReg();
    fetchClasses();
    fetchAcademicYears();
  }, [])


  useEffect(() => {
    if (selectedClassId) {
  const selectedClass = classes.find((cls) => cls.id === Number(selectedClassId));
  
      if (selectedClass && selectedClass.sections) {
        const sectionArray = selectedClass.sections
          .split(',')
          .map((s) => s.trim()) 
          .filter((s) => s !== '');
  
        setAvailableSections(sectionArray);
      } else {
        setAvailableSections([]);
      }
  
      setSelectedSection('');
    }
  }, [selectedClassId, classes]);
  

  useEffect(() => {
  setFormData((prev) => ({
    ...prev,
    class_id: selectedClassId,
  }));
}, [selectedClassId]);

useEffect(() => {
  setFormData((prev) => ({
    ...prev,
    section: selectedSection,
  }));
}, [selectedSection]);

      
  return (
    <>
                <section className='py-4'>
      <div className='px-4'>

      <HeadingArea message1='Student' message2='New Student' />

<div className='d-md-flex justify-content-between'>
      <button className='mt-2 profile-btn2' onClick={() => window.open('https://api.kcian.in/inUploads/student_data_format.xlsx', '_blank')}>Get Format</button>
      <div>
<button
  className='mt-2 profile-btn me-3'
  onClick={() => {
    setShowUploadSheet(true);
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  }}
>
  Upload Data Sheet
</button>

      <button className='mt-2 profile-btn me-3' onClick={handleButtonClick}>Upload Images</button>
      <button className='mt-2 profile-btn me-3' onClick={() => pdfInputRef.current.click()}>Upload Aadhaar Pdf</button>
      </div>
</div>

<input
        type="file"
        multiple
        accept="image/*"
        style={{ display: 'none' }}
        ref={imageInputRef}
        onChange={handleImageChange}
      />

 <input
        type="file"
        accept="application/pdf"
        multiple
        ref={pdfInputRef}
        style={{ display: "none" }}
        onChange={handlePdfChange}
      />

      {selectedFiles.length > 0 && (
        <div className='mt-3 text-end'>
          <p>{selectedFiles.length} file(s) selected</p>
          <button className="profile-btn2" onClick={handleUpload}>
            Submit Upload
          </button>
        </div>
      )}


      

{showUploadSheet && 
<input
  type="file"
  ref={fileInputRef}
  style={{ display: 'none' }}
  onChange={handleFileChange}
/>
}

       {response2.message && <ResponseMsg2 message={response2.message} status={response2.status} />}

                  <p className='text-center profile-heading mt-4'>Student Form</p>

  <form onSubmit={handleSubmit}>
<div className='row'>

    <p className='fw-semibold border-bottom mb-5'><Bs1CircleFill /> Basic Information</p>
            {/* Reg No */}
            <div className='mb-4 col-md-4'>
              <div className='profile-input-area'>
                <label className='profile-badge'>{lastReg == null ? 'Registration No' : `Last Reg No ${lastReg}`}</label>
                <input type='text' name='reg_no' value={formData.reg_no} onChange={handleChange} className='profile-input' />
              </div>
            </div>


            {/* Admission No */}
            <div className='mb-4 col-md-4'>
              <div className='profile-input-area'>
                <label className='profile-badge'>Admission No*</label>
                <input type='text' name='admission_no' value={formData.admission_no} onChange={handleChange} className='profile-input' required />
              </div>
            </div>

{/* Pen no */}
            <div className='mb-4 col-md-4'>
              <div className='profile-input-area'>
                <label className='profile-badge'>PEN No</label>
                <input type='text' name='pen_no' value={formData.pen_no} onChange={handleChange} className='profile-input' />
              </div>
            </div>

            {/* Name */}
            <div className='mb-4 col-md-4'>
              <div className='profile-input-area'>
                <label className='profile-badge'>Full Name*</label>
                <input type='text' name='name' value={formData.name} onChange={handleChange} className='profile-input' required />
              </div>
            </div>



            {/* Roll no */}
            <div className='mb-4 col-md-4'>
              <div className='profile-input-area'>
                <label className='profile-badge'>Roll No*</label>
                <input type='text' name='roll_no' value={formData.roll_no} onChange={handleChange} className='profile-input' required />
              </div>
            </div>


           {/* Mobile */}
            <div className='mb-4 col-md-4'>
              <div className='profile-input-area'>
                <label className='profile-badge'>Mobile Number*</label>
                <input type='tel' name='mobile' value={formData.mobile} maxLength={10} onChange={handleChange} className='profile-input' required />
              </div>
            </div>

{/* Date of Birth */}
            <div className='mb-4 col-md-4'>
              <div className='profile-input-area'>
                <label className='profile-badge'>Date of Birth</label>
                <input type='date' name='dob' value={formData.dob} onChange={handleChange} className='profile-input' />
              </div>
            </div>


{/* DOR */}
            <div className='mb-4 col-md-4'>
              <div className='profile-input-area'>
                <label className='profile-badge'>Date of Registration</label>
                <input type='date' name='dor_reg' value={formData.dor_reg} onChange={handleChange} className='profile-input' />
              </div>
            </div>


            {/* DOA */}
            <div className='mb-4 col-md-4'>
              <div className='profile-input-area'>
                <label className='profile-badge'>Date of Admission*</label>
                <input type='date' name='doa' value={formData.doa} onChange={handleChange} className='profile-input' required />
              </div>
            </div>


            {/* Password */}
<div className='mb-4 col-md-4'>
  <div className='profile-input-area' style={{ position: 'relative' }}>
    <label className='profile-badge'>Password*</label>
    <input
      type={showPassword ? 'text' : 'password'}
      name='pass'
      value={formData.pass}
      onChange={handleChange}
      className='profile-input'
      readOnly
      required
    />
    <span
      onClick={() => setShowPassword((prev) => !prev)}
      style={{
        position: 'absolute',
        right: '15px',
        top: '15px',
        cursor: 'pointer',
        color: '#888'
      }}
    >
      {showPassword ? <FaEyeSlash size={20} /> : <FaEye size={20} />}
    </span>
  </div>
</div>


                  <div className="mb-4 col-md-4">
              <div className='profile-input-area'>
                    <label className="profile-badge">Select AY*</label>
                    <select
                      className="profile-input"
                      name='ay'
                      value={formData.ay}
      onChange={handleChange}
                      required
                    >
                      <option value="">-- Select Academic Year --</option>
                      {ay.map((ayear) => (
                        <option key={ayear.year} value={ayear.year}>
                          {ayear.year} --- {ayear.title}
                        </option>
                      ))}
                    </select>
</div>
                  </div>


                  <div className="mb-4 col-md-4">
              <div className='profile-input-area'>
                    <label className="profile-badge">Select Class*</label>
                    <select
                      className="profile-input"
                      value={selectedClassId}
                      onChange={(e) => setSelectedClassId(e.target.value)}
                      required
                    >
                      <option value="">-- Select Class --</option>
                      {classes.map((cls) => (
                        <option key={cls.id} value={cls.id}>
                          {cls.class_name}
                        </option>
                      ))}
                    </select>
</div>
                  </div>

                  {/* Select Section */}
                  <div className="mb-4 col-md-4">
              <div className='profile-input-area'>
                    <label className="profile-badge">Select Section*</label>
<select
  className="profile-input"
  value={selectedSection}
  onChange={(e) => setSelectedSection(e.target.value)}
  required
  disabled={availableSections.length === 0}
>
  <option value="">-- Select Section --</option>
  {availableSections.map((section, idx) => (
    <option key={idx} value={section}>
      {section}
    </option>
  ))}
</select>

                    </div>
                  </div>


{/* Fee Discount */}
            {/* <div className='mb-4 col-md-4'>
              <div className='profile-input-area'>
                <label className='profile-badge'>Discount on Fee (If Any)</label>
                <input type='text' name='fee_discount' value={formData.fee_discount} onChange={handleChange} className='profile-input' placeholder='e.g 500 or 5%' />
              </div>
            </div> */}


            <div className='mb-4 col-md-4'>
              <div className='profile-input-area'>
                <label className='profile-badge'>Category</label>
                <select name='category' value={formData.category} onChange={handleChange} className='profile-input'>
                  <option value=''>Select Category</option>
                  <option value='General'>General</option>
                  <option value='EWS'>EWS</option>
                  <option value='OBC'>OBC</option>
                  <option value='SC'>SC</option>
                  <option value='ST'>ST</option>
                  <option value='Other'>Other</option>
                </select>
              </div>
            </div>


{/* Pen no */}
            <div className='mb-4 col-md-4'>
              <div className='profile-input-area'>
                <label className='profile-badge'>Apaar Id</label>
                <input type='text' name='apaar_no' value={formData.apaar_no} onChange={handleChange} className='profile-input' />
              </div>
            </div>


    <p className='fw-semibold border-bottom mb-5'><Bs2CircleFill /> Aadhaar Details</p>


{/* Aadhar no */}
            <div className='mb-4 col-md-4'>
              <div className='profile-input-area'>
                <label className='profile-badge'>Aadhaar No</label>
                <input type='text' name='aadhaar_no' value={formData.aadhaar_no} onChange={handleChange} className='profile-input' />
              </div>
            </div>


            <div className='mb-4 col-md-4'>
              <div className='profile-input-area'>
                <label className='profile-badge'>Aadhaar Pdf</label>
                <input type='file' name='aadhaar_pic' accept='application/pdf' onChange={handleChange} className='profile-input' />
              </div>
            </div>

            <p className='para-text fw-bold mb-4'>Whether the candidate is: -</p>


{/* Single Girl Child */}
<div className='mb-4 col-md-4'>
  <div className='profile-input-area border-0'>
    <label className='profile-badge'>Single Girl Child?</label>
    <div className="d-flex gap-3 mt-3">
      <button
        type="button"
        className={`btn px-2 py-0 ${formData.single_girl_child === 'Yes' ? 'btn-success' : 'btn-outline-secondary'}`}
        onClick={() => setFormData((prev) => ({ ...prev, single_girl_child: 'Yes' }))}
      >
        Yes
      </button>
      <button
        type="button"
        className={`btn px-2 py-0 ${formData.single_girl_child === 'No' || !formData.single_girl_child ? 'btn-danger' : 'btn-outline-secondary'}`}
        onClick={() => setFormData((prev) => ({ ...prev, single_girl_child: 'No' }))}
      >
        No
      </button>
    </div>
  </div>
</div>

{/* Specially Abled */}
<div className='mb-4 col-md-4'>
  <div className='profile-input-area border-0'>
    <label className='profile-badge'>Specially abled?</label>
    <div className="d-flex gap-3 mt-3">
      <button
        type="button"
        className={`btn px-2 py-0 ${formData.specially_abled === 'Yes' ? 'btn-success' : 'btn-outline-secondary'}`}
        onClick={() => setFormData((prev) => ({ ...prev, specially_abled: 'Yes' }))}
      >
        Yes
      </button>
      <button
        type="button"
        className={`btn px-2 py-0 ${formData.specially_abled === 'No' || !formData.specially_abled ? 'btn-danger' : 'btn-outline-secondary'}`}
        onClick={() => setFormData((prev) => ({ ...prev, specially_abled: 'No' }))}
      >
        No
      </button>
    </div>
  </div>
</div>



    <p className='fw-semibold border-bottom mb-5'><Bs3CircleFill /> Other Information</p>

            {/* Profile Picture */}
            <div className='mb-4 col-md-4'>
              <div className='profile-input-area'>
                <label className='profile-badge'>Profile Picture</label>
                <input type='file' name='profile_pic' onChange={handleChange} className='profile-input' />
              </div>
            </div>

            {/* Blood Group */}
            <div className='mb-4 col-md-4'>
              <div className='profile-input-area'>
                <label className='profile-badge'>Blood Group</label>
                <input type='text' name='blood_grp' value={formData.blood_grp} onChange={handleChange} className='profile-input' />
              </div>
            </div>

            {/* User ID */}
            <div className='mb-4 col-md-4'>
              <div className='profile-input-area'>
                <label className='profile-badge'>Email Address</label>
                <input type='email' name='email' value={formData.email} onChange={handleChange} className='profile-input' />
              </div>
            </div>

            {/* Gender */}
            <div className='mb-4 col-md-4'>
              <div className='profile-input-area'>
                <label className='profile-badge'>Gender</label>
                <select name='gender' value={formData.gender} onChange={handleChange} className='profile-input'>
                  <option value=''>Select Gender</option>
                  <option value='Male'>Male</option>
                  <option value='Female'>Female</option>
                  <option value='Other'>Other</option>
                </select>
              </div>
            </div>


{/* Religion */}
            <div className='mb-4 col-md-4'>
              <div className='profile-input-area'>
                <label className='profile-badge'>Religion</label>
                <select name='religion' value={formData.religion} onChange={handleChange} className='profile-input'>
                  <option value=''>Select Religion</option>
                  <option value='Hinduism'>Hinduism</option>
                  <option value='Muslim'>Muslim</option>
                  <option value='Non Muslim'>Non Muslim</option>
                  <option value='Christianity'>Christianity</option>
                  <option value='Islam'>Islam</option>
                  <option value='Jainism'>Jainism</option>
                  <option value='Buddhism'>Buddhism</option>
                   <option value='Sikhism'>Sikhism</option>
                  <option value='Non Religious'>Non Religious</option>
                  <option value='Other'>Other</option>
                </select>
              </div>
            </div>


{/* Nationality */}
            <div className='mb-4 col-md-4'>
              <div className='profile-input-area'>
                <label className='profile-badge'>Nationality</label>
                <input type='text' name='nationality' value={formData.nationality} onChange={handleChange} className='profile-input' />
              </div>
            </div>

{/* mother tongue */}
            <div className='mb-4 col-md-4'>
              <div className='profile-input-area'>
                <label className='profile-badge'>Mother Tongue</label>
                <input type='text' name='m_tongue' value={formData.m_tongue} onChange={handleChange} className='profile-input' />
              </div>
            </div>

{/* TC No */}
            <div className='mb-4 col-md-4'>
              <div className='profile-input-area'>
                <label className='profile-badge'>TC (Transfer Certificate) No</label>
                <input type='text' name='tc_no' value={formData.tc_no} onChange={handleChange} className='profile-input' />
              </div>
            </div>

            {/* TC Date */}
            <div className='mb-4 col-md-4'>
              <div className='profile-input-area'>
                <label className='profile-badge'>TC Issue Date</label>
                <input type='date' name='tc_issue_date' value={formData.tc_issue_date} onChange={handleChange} className='profile-input' />
              </div>
            </div>

            {/* Address */}
            <div className='mb-4 mt-2 col-md-6 col-12'>
              <div className='profile-input-area'>
                <label className='profile-badge'>Address</label>
                <textarea name='address' value={formData.address} onChange={handleChange} className='profile-input' rows='3' />
              </div>
            </div>

            {/* Old School */}
            <div className='mb-4 mt-2 col-md-6 col-12'>
              <div className='profile-input-area'>
                <label className='profile-badge'>Old School Detail</label>
                <textarea name='old_school_detail' value={formData.old_school_detail} onChange={handleChange} className='profile-input' rows='3' />
              </div>
            </div>



                <p className='fw-semibold border-bottom mb-5'><Bs4CircleFill /> Guardian Details</p>

{/* Father name */}
            <div className='mb-4 col-md-4'>
              <div className='profile-input-area'>
                <label className='profile-badge'>Father Name</label>
                <input type='text' name='father' value={formData.father} onChange={handleChange} className='profile-input' />
              </div>
            </div>

{/* occupation */}
            <div className='mb-4 col-md-4'>
              <div className='profile-input-area'>
                <label className='profile-badge'>Occupation</label>
                <input type='text' name='f_occupation' value={formData.f_occupation} onChange={handleChange} className='profile-input' />
              </div>
            </div>

{/* mobile */}
            <div className='mb-4 col-md-4'>
              <div className='profile-input-area'>
                <label className='profile-badge'>Father's Mobile No</label>
                <input type='tel' name='f_mobile' value={formData.f_mobile} maxLength={10} onChange={handleChange} className='profile-input' />
              </div>
            </div>

{/* email */}
            <div className='mb-4 col-md-4'>
              <div className='profile-input-area'>
                <label className='profile-badge'>Father's Email</label>
                <input type='text' name='f_email' value={formData.f_email} onChange={handleChange} className='profile-input' />
              </div>
            </div>

{/* qualification */}
            <div className='mb-4 col-md-4'>
              <div className='profile-input-area'>
                <label className='profile-badge'>Father's Qualification</label>
                <input type='text' name='f_qualification' value={formData.f_qualification} onChange={handleChange} className='profile-input' />
              </div>
            </div>

            <div className='mb-4 col-md-4'>
</div>

{/* Mother name */}
            <div className='mb-4 col-md-4'>
              <div className='profile-input-area'>
                <label className='profile-badge'>Mother Name</label>
                <input type='text' name='mother' value={formData.mother} onChange={handleChange} className='profile-input' />
              </div>
            </div>


{/* occupation */}
            <div className='mb-4 col-md-4'>
              <div className='profile-input-area'>
                <label className='profile-badge'>Occupation</label>
                <input type='text' name='m_occupation' value={formData.m_occupation} onChange={handleChange} className='profile-input' />
              </div>
            </div>


                        <div className='mb-4 col-md-4'>
              <div className='profile-input-area'>
                <label className='profile-badge'>Mother's Mobile No</label>
                <input type='tel' name='m_mobile' value={formData.m_mobile} maxLength={10} onChange={handleChange} className='profile-input' />
              </div>
            </div>

{/* email */}
            <div className='mb-4 col-md-4'>
              <div className='profile-input-area'>
                <label className='profile-badge'>Mother's Email</label>
                <input type='text' name='m_email' value={formData.m_email} onChange={handleChange} className='profile-input' />
              </div>
            </div>

{/* qualification */}
            <div className='mb-4 col-md-4'>
              <div className='profile-input-area'>
                <label className='profile-badge'>Mother's Qualification</label>
                <input type='text' name='m_qualification' value={formData.m_qualification} onChange={handleChange} className='profile-input' />
              </div>
            </div>

            <div className='mb-4 col-md-4'>
</div>



                <p className='fw-semibold border-bottom mb-5'><Bs5CircleFill /> Siblings Details (if Any)</p>

<div className='col-12'>
  {formData.siblings.length > 0 &&
    formData.siblings.map((sibling, index) => (
      <div key={index} className='row align-items-end mb-4'>
        <div className='col-md-3'>
          <div className='profile-input-area'>
            <label className='profile-badge'>Name</label>
            <input
              type='text'
              className='profile-input'
              value={sibling.name}
              onChange={(e) => {
                const updated = [...formData.siblings];
                updated[index].name = e.target.value;
                setFormData({ ...formData, siblings: updated });
              }}
            />
          </div>
        </div>

        <div className='col-md-3'>
          <div className='profile-input-area'>
            <label className='profile-badge'>Relation</label>
            <select
              className='profile-input'
              value={sibling.relation}
              onChange={(e) => {
                const updated = [...formData.siblings];
                updated[index].relation = e.target.value;
                setFormData({ ...formData, siblings: updated });
              }}
            >
              <option value=''>Select</option>
              <option value='Brother'>Brother</option>
              <option value='Sister'>Sister</option>
            </select>
          </div>
        </div>

        <div className='col-md-2'>
          <div className='profile-input-area'>
            <label className='profile-badge'>Age</label>
            <input
              type='number'
              className='profile-input'
              value={sibling.age}
              onChange={(e) => {
                const updated = [...formData.siblings];
                updated[index].age = e.target.value;
                setFormData({ ...formData, siblings: updated });
              }}
            />
          </div>
        </div>

        <div className='col-md-3'>
          <div className='profile-input-area'>
            <label className='profile-badge'>School Studying</label>
            <input
              type='text'
              className='profile-input'
              value={sibling.school_studying}
              onChange={(e) => {
                const updated = [...formData.siblings];
                updated[index].school_studying = e.target.value;
                setFormData({ ...formData, siblings: updated });
              }}
            />
          </div>
        </div>

        <div className='col-md-1 text-end'>
          <button
            type='button'
            className='btn btn-danger rounded-circle'
            onClick={() => {
              const updated = [...formData.siblings];
              updated.splice(index, 1);
              setFormData({ ...formData, siblings: updated });
            }}
          >
            −
          </button>
        </div>
      </div>
    ))}

  <button
    type='button'
    className='profile-btn2 float-end'
    onClick={() =>
      setFormData({
        ...formData,
        siblings: [
          ...formData.siblings,
          { name: '', relation: '', age: '', school_studying: '' }
        ]
      })
    }
  >
    + Add Sibling
  </button>
</div>



<div className='px-2'>
       {response2.message && <ResponseMsg2 message={response2.message} status={response2.status} />}</div>

 <div className='col-12 mt-4'>
                <button type='submit' className='profile-btn'><FaCheck /> Submit</button>
              </div>


</div>
</form>
{/* row ends */}

</div>
</section>
    </>
  )
}

export default AddStudent
